import React from 'react'
import { useIntl } from 'react-intl'
import { SigningStatus } from './s'
import Label from './label'
import Details from './details'

const DocumentSigningStatus = ({ signing, withIcon = false, className }) => {
    if(!signing) {
        return null
    }

    return (
        <SigningStatus className={className}>
            <Label
                {...signing}
                withIcon={withIcon} />
            <Details {...signing} />
        </SigningStatus>
    )
}

const statusTexts = {
    // Special
    any: {
        id: 'document_signing_status_any',
        defaultMessage: 'All signature documents'
    },

    // Neutral
    pending: {
        id: 'document_signing_status_pending',
        defaultMessage: 'Pending'
    },

    // All good
    closed: {
        id: 'document_signing_status_signed',
        defaultMessage: 'Signed'
    },

    // Not signed but salvagable
    canceled: {
        id: 'document_signing_status_withdrawn',
        defaultMessage: 'Withdrawn'
    },
    timedout: {
        id: 'document_signing_status_expired',
        defaultMessage: 'Expired'
    },

    // Failed
    rejected: {
        id: 'document_signing_status_rejected',
        defaultMessage: 'Rejected'
    },
    document_error: {
        id: 'document_signing_status_error',
        defaultMessage: 'Scrive error'
    }
}

export const useDocumentSigningStatusTextFormatter = () => {
    const { formatMessage } = useIntl()

    return status => {
        const message = statusTexts[status] ?? null

        return message ?
            formatMessage(message) :
            null
    }
}

export default DocumentSigningStatus